import React from 'react';
import { useInView } from '../hooks/useInView';
import { CheckCircle2 } from 'lucide-react';
export function BonusBox() {
  const {
    ref,
    isVisible
  } = useInView();
  const bonuses = ["Il Kit Legale di Sicurezza — Modulistica pronta all'uso", '50 Idee per Reels e Post — Strategia Social completa', 'Il Planner Settimanale Success-Flow — Organizza ogni settimana', 'Protocollo Fast-Recovery (Sedia) — Esercizi di recupero rapido', 'Dizionario Tecnico Poliglotta — Terminologia in 4 lingue'];
  return <section className="bg-[#F1F1F1] py-12 md:py-20 px-4" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-15">
          <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-brand p-6 md:p-10" data-id="element-16">
            <h2 className="font-heading text-xl md:text-3xl text-headline font-extrabold text-center mb-2 tracking-tight" data-id="element-17">
              REGALO ESCLUSIVO
            </h2>
            <p className="text-cta font-heading font-bold text-sm md:text-lg text-center mb-8" data-id="element-18">
              5 Bonus (Valore €147) GRATIS oggi.
            </p>

            <div className="space-y-4" data-id="element-19">
              {bonuses.map((bonus, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-20">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" strokeWidth={2} data-id="element-21" />
                  <p className="text-body text-sm md:text-base font-light leading-relaxed" data-id="element-22">
                    {bonus}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}